import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TextBlock } from '../../model/nsc-consent-legal-text';

@Component({
  selector: 'cdf-legal-text',
  imports: [],
  host: {
    '[class.plain-text]': '!legalText().isHtml',
  },
  template: `
    @if (legalText().isHtml) {
      <span [innerHTML]="legalText().text"></span>
    } @else {
      {{ legalText().text }}
    }
  `,
  styleUrl: './legal-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalTextComponent {
  readonly legalText = input.required<TextBlock>();
}
